module.exports = __webpack_public_path__ + "static/rewards-centered-ef108f5b748641c78a3f462cb4da9a67.png";